import { useContext } from "react"
import LayoutContext from "../context/layout/LayoutContext"

export const useLayout = () => {
    return useContext(LayoutContext)
}